// extracted by mini-css-extract-plugin
export default {"root":"AuthLayout_root__tFJXC","container":"AuthLayout_container__PXUB5","bg":"AuthLayout_bg__vz6K2","logo":"AuthLayout_logo__ODFCr"};